var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 16.3821,
    cy: 16.714,
    rx: 16.3821,
    ry: 16.5714,
    fill: "#166649"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7152 8.93652H8.0485C7.13184 8.93652 6.38184 9.68652 6.38184 10.6032V22.8254C6.38184 23.7421 7.13184 24.4921 8.0485 24.4921H24.7152C25.6318 24.4921 26.3818 23.7421 26.3818 22.8254V10.6032C26.3818 9.68652 25.6318 8.93652 24.7152 8.93652ZM25.2707 22.8254C25.2707 23.131 25.0207 23.381 24.7152 23.381H8.0485C7.74295 23.381 7.49295 23.131 7.49295 22.8254V14.4921H25.2707V22.8254ZM25.2707 13.381H7.49295V12.2699H25.2707V13.381ZM25.2707 11.1587H7.49295V10.6032C7.49295 10.2976 7.74295 10.0476 8.0485 10.0476H24.7152C25.0207 10.0476 25.2707 10.2976 25.2707 10.6032V11.1587Z",
    fill: "#004431"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4929 17.8252H8.63184V18.9363H17.4929V17.8252Z",
    fill: "#004431"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0763 20.0479H8.63184V21.159H13.0763V20.0479Z",
    fill: "#004431"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit-card-icon.e35a281b07488a7b1a8a650a8328d6b7.svg";
export { ForwardRef as ReactComponent };